import React from 'react'
import type { PropsWithChildren } from 'react'
import { Box, Typography, Button } from '@mui/material'
import Page from 'components/Page'
import { appVersions, FF_FAVUR_REDESIGN } from 'constants/featureFlags'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useFeatureFlag from 'hooks/useFeatureFlag'
import RedesignThemeWrapper from 'redesign/components/atoms/RedesignThemeWrapper'
import RedesignedUpdateApp from 'redesign/components/templates/UpdateApp'
import VersionRequirementDialog from './VersionRequirementDialog'
import { classes } from './styles'
import useUpdateApp from './useUpdateApp'

const UpdateApp: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useFavurTranslation()
  const props = useUpdateApp()
  const { meetsRequired, FFVersion, showDialog, redirect, dismissDialog } = props
  const redesignFF = Boolean(useFeatureFlag(FF_FAVUR_REDESIGN))

  // TODO: Remove once the redesign is done
  if (redesignFF) {
    return <RedesignedUpdateApp {...props}>{children}</RedesignedUpdateApp>
  }

  if (!meetsRequired || FFVersion === appVersions.beforeRequired) {
    return (
      <RedesignThemeWrapper>
        <Page hideNativeNavigation hideWebToolbar flex showHeader hideHamburger>
          <Box sx={classes.content}>
            <Box sx={classes.imageContainer}>
              <img
                src="/assets/images/UpdateApp/UpdateApp.png"
                alt="Update application"
                data-testid="update-app-image"
              />
              <Typography variant="h1" sx={classes.title} align="center">
                {t('updateApp.title')}
              </Typography>
              <Typography variant="body1" sx={classes.text}>
                {t('updateApp.text')}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center">
              <Button size="large" variant="contained" color="secondary" onClick={redirect}>
                {t('updateApp.button')}
              </Button>
            </Box>
          </Box>
        </Page>
      </RedesignThemeWrapper>
    )
  }

  return (
    <>
      <RedesignThemeWrapper>{showDialog && <VersionRequirementDialog dismiss={dismissDialog} />}</RedesignThemeWrapper>
      {children}
    </>
  )
}

export default UpdateApp
